import script from "./UIEmojis.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIEmojis.vue?vue&type=script&lang=ts&setup=true"

import "./UIEmojis.vue?vue&type=style&index=0&id=10464727&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10464727"]])

export default __exports__